const COLORS = ['#0a2540', '#0f3460', '#00b4d8', '#f97316', '#0a2540', '#0f3460', '#00b4d8', '#f97316'];

export const projects = [
  {
    id: 1,
    featured: true,
    category: 'Automotive',
    title: 'Material Handling System Installation',
    description:
      'Installed pallet trucks, stackers, and lifting equipment for smooth material movement within an automotive manufacturing facility.',
    outcomes: [
      'Improved workflow efficiency',
      'Reduced manual handling effort',
      'Safe and reliable operations',
    ],
    color: COLORS[0],
  },
  {
    id: 2,
    featured: true,
    category: 'Warehouse & Logistics',
    title: 'Warehouse Loading & Handling Solution',
    description:
      'Supplied dock levellers and pallet handling equipment to optimize warehouse loading and unloading processes.',
    outcomes: [
      'Faster goods movement',
      'Streamlined warehouse operations',
      'Durable industrial equipment',
    ],
    color: COLORS[1],
  },
  {
    id: 3,
    featured: true,
    category: 'Pharmaceutical',
    title: 'Hygienic Material Movement Setup',
    description:
      'Provided stainless steel pallet trucks and stackers suitable for clean and hygienic industrial environments.',
    outcomes: [
      'Corrosion-resistant equipment',
      'Easy material transportation',
      'Low-maintenance operation',
    ],
    color: COLORS[2],
  },
  {
    id: 4,
    featured: false,
    category: 'E-Commerce',
    title: 'Inventory Handling Improvement',
    description:
      'Installed pallet handling and lifting solutions for efficient inventory movement and warehouse management.',
    outcomes: [
      'Smooth internal logistics',
      'Improved operational efficiency',
      'Easy handling of palletized goods',
    ],
    color: COLORS[3],
  },
  {
    id: 5,
    featured: true,
    category: 'Steel & Heavy Industry',
    title: 'Heavy Load Handling Solution',
    description:
      'Delivered floor cranes and lifting systems designed for safe handling of heavy industrial materials.',
    outcomes: [
      'Strong load handling support',
      'Reliable lifting performance',
      'Industrial-grade durability',
    ],
    color: COLORS[4],
  },
  {
    id: 6,
    featured: false,
    category: 'FMCG',
    title: 'Multi-Floor Goods Transfer System',
    description:
      'Installed goods lifts and platform handling systems for efficient movement of packaged products across facility levels.',
    outcomes: [
      'Safe vertical transportation',
      'Efficient material flow',
      'Smooth daily operations',
    ],
    color: COLORS[5],
  },
  {
    id: 7,
    featured: false,
    category: 'Chemical Industry',
    title: 'Drum Handling Equipment Installation',
    description:
      'Provided drum handling and lifting equipment for safe transportation and positioning of industrial drums.',
    outcomes: [
      'Enhanced workplace safety',
      'Easy drum movement',
      'Reduced manual effort',
    ],
    color: COLORS[6],
  },
  {
    id: 8,
    featured: false,
    category: 'Retail & Distribution',
    title: 'Warehouse Equipment Deployment',
    description:
      'Supplied pallet trucks and dock levellers to support warehouse dispatch and storage operations.',
    outcomes: [
      'Optimized loading activities',
      'Better warehouse organization',
      'Reliable material handling support',
    ],
    color: COLORS[7],
  },
];

/** Shown on homepage — four diverse industries, fits 4-column grid */
export const featuredProjects = projects.filter((p) => p.featured);
